export default __webpack_public_path__ + "locales/es/SharingPanel.json?hash=da50b8a472084784648dded9d22ebfd7";